/** Figma `Badge` 세트(Components, 7:74)의 축. `style` 축은 코드에서 `appearance`(fe-rules 1절) */
export const BADGE_TONES = [
  'neutral',
  'primary',
  'success',
  'warning',
  'danger',
  'info',
  'secondary',
] as const;
export type BadgeTone = (typeof BADGE_TONES)[number];

export const BADGE_APPEARANCES = ['subtle', 'solid', 'outline'] as const;
export type BadgeAppearance = (typeof BADGE_APPEARANCES)[number];

/** sm 18 · md 24 · lg 28 */
export const BADGE_SIZES = ['sm', 'md', 'lg'] as const;
export type BadgeSize = (typeof BADGE_SIZES)[number];

export const BADGE_STATUSES = ['default', 'init'] as const;
export type BadgeStatus = (typeof BADGE_STATUSES)[number];

/** 면 · 글자 · 테두리 색. neutral solid 는 중간 회색 + 어두운 글자(DD-8 A5) */
export const BADGE_TONE_CLASS: Record<BadgeAppearance, Record<BadgeTone, string>> = {
  subtle: {
    neutral: 'bg-bg-muted text-fg-muted',
    primary: 'bg-bg-primary-subtle text-fg-primary',
    success: 'bg-bg-success-subtle text-fg-success',
    warning: 'bg-bg-warning-subtle text-fg-warning',
    danger: 'bg-bg-danger-subtle text-fg-danger',
    info: 'bg-bg-info-subtle text-fg-info',
    secondary: 'bg-bg-secondary-subtle text-fg-secondary',
  },
  solid: {
    neutral: 'bg-bg-neutral text-on-neutral',
    primary: 'bg-bg-primary text-on-primary',
    success: 'bg-bg-success text-on-success',
    warning: 'bg-bg-warning text-on-warning',
    danger: 'bg-bg-danger text-on-danger',
    info: 'bg-bg-info text-on-info',
    secondary: 'bg-bg-secondary text-on-secondary',
  },
  outline: {
    neutral: 'border border-fg-muted bg-bg-surface text-fg-muted',
    primary: 'border border-fg-primary bg-bg-surface text-fg-primary',
    success: 'border border-fg-success bg-bg-surface text-fg-success',
    warning: 'border border-fg-warning bg-bg-surface text-fg-warning',
    danger: 'border border-fg-danger bg-bg-surface text-fg-danger',
    info: 'border border-fg-info bg-bg-surface text-fg-info',
    secondary: 'border border-fg-secondary bg-bg-surface text-fg-secondary',
  },
};

/** 모서리: solid 는 각지고, subtle · outline 은 4 */
export const BADGE_SHAPE_CLASS: Record<BadgeAppearance, string> = {
  subtle: 'rounded-sm',
  solid: 'rounded-none',
  outline: 'rounded-sm',
};

/**
 * 높이 · 글자. sm 은 글자 높이(14) + 위아래 2(raw 예외 — 간격 토큰에 없는 값)로 18 이 되고,
 * outline 은 테두리 1 이 더해져 20 이다(Figma 와 같다). md 24 · lg 28 은 높이를 고정한다.
 */
export const BADGE_SIZE_CLASS: Record<BadgeSize, string> = {
  sm: 'typo-caption-sm',
  md: 'h-(--size-control-2xs) typo-label-sm',
  lg: 'h-(--size-control-xs) typo-body-sm-strong',
};

/** 좌우 여백. solid sm 만 4, 나머지 sm · md 8, lg 10 */
export const BADGE_PADDING_CLASS: Record<BadgeAppearance, Record<BadgeSize, string>> = {
  subtle: { sm: 'px-2', md: 'px-2', lg: 'px-2-5' },
  solid: { sm: 'px-1', md: 'px-2', lg: 'px-2-5' },
  outline: { sm: 'px-2', md: 'px-2', lg: 'px-2-5' },
};

/** sm 의 위아래 2 는 글자 칸의 투명 테두리로 낸다(`py-0.5` 는 토큰에 없다) */
export const BADGE_LABEL_CLASS: Record<BadgeSize, string> = {
  sm: 'border-y-2 border-transparent',
  md: '',
  lg: '',
};
